<template>
<div v-if="this.params.value" style="text-align:right">
    {{this.params.value.toFixed(2)}} %
</div>
</template>